module.exports = __webpack_public_path__ + "static/nextlevel-sm-detail-28a4c7a612f9eef76c563f430e6888d9.jpg";